import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const MainContainer = styled.div`
    min-height: 100%;
    display: flex;
    flex-direction: column;
    ${({ theme: { color, fontSize } }) => css`
        background-color: ${color.black};
        color: ${color.gray2};
        font-size: ${fontSize.medium};
    `};
`;

export const ContentContainer = styled.div`
    position: relative;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
`;
